import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import styles from './../Home.module.css';

import { AppContext } from '../../services/AppContext';
import { Footer } from '../../components/Footer';
import { LoginModal } from '../LoginModal';
import { Navbar, Toolbar } from '../Home';

/*COVERS*/
import compliance2020 from './covers/compliance-2020.jpg';
import compliance2021 from './covers/compliance-2021.jpg';
import compliance2022 from './covers/compliance-2022.jpg';
import compliance2023 from './covers/compliance-2023.jpg';
import compliance2024 from './covers/compliance-2024.jpg';
import compliance2025 from './covers/compliance-2025.jpg';
import consent2019 from './covers/consent-2019.jpg';
import consent2020 from './covers/consent-2020.jpg';
import consent2021 from './covers/consent-2021.jpg';
import consent2023 from './covers/consent-2023.jpg';
import mental2019 from './covers/mental-2019.jpg';
import mental2021 from './covers/mental-2021.jpg';

const ISSUES_SET = {
  compliance: [
    {
			id: 'compliance-2025',
			cover: compliance2025,
			url: '/issues/compliance-2025',
		},
		{
			id: 'compliance-2024',
			cover: compliance2024,
			url: '/issues/compliance-2024',
		},
		{
			id: 'compliance-2023',
			cover: compliance2023,
			url: '/issues/compliance-2023',
		},
		{
			id: 'compliance-2022',
			cover: compliance2022,
			url: 'https://cdn.pwa.canvasflow.io/custom_assets/cha/archive/pdf/compliance2022.pdf',
		},
		{
			id: 'compliance-2021',
			cover: compliance2021,
			url: 'https://cdn.pwa.canvasflow.io/custom_assets/cha/archive/pdf/compliance2021.pdf',
		},
		{
			id: 'compliance-2020',
			cover: compliance2020,
			url: 'https://cdn.pwa.canvasflow.io/custom_assets/cha/archive/pdf/compliance2020.pdf',
		},
	],
	consent: [
		{
			id: 'consent-2023',
			cover: consent2023,
			url: 'https://cdn.pwa.canvasflow.io/custom_assets/cha/archive/pdf/consent2023.pdf',
		},
		{
			id: 'consent-2021',
			cover: consent2021,
			url: '/issues/consent-2021',
		},
		{
			id: 'consent-2020',
			cover: consent2020,
			url: 'https://cdn.pwa.canvasflow.io/custom_assets/cha/archive/pdf/consent2020.pdf',
		},
		{
			id: 'consent-2019',
			cover: consent2019,
			url: 'https://cdn.pwa.canvasflow.io/custom_assets/cha/archive/pdf/consent2019.pdf',
		},
	],
	mental: [
		{
			id: 'mental-health-2021',
			cover: mental2021,
			url: 'https://cdn.pwa.canvasflow.io/custom_assets/cha/archive/pdf/Mental-Health-Law-Manual-2021.pdf',
		},
		{
			id: 'mental-health-2019',
			cover: mental2019,
			url: 'https://cdn.pwa.canvasflow.io/custom_assets/cha/archive/pdf/mentalhealth2019.pdf',
		},
	],
};

export function Archive() {
	return <ChaLayout />;
}

function ChaLayout() {
	const [isLoginOpen, setIsLoginOpen] = useState(false);

	return (
		<>
			<LoginModal
				isOpen={isLoginOpen}
				onClose={() => {
					setIsLoginOpen(false);
				}}
			/>
			<div className={[styles['cha'], styles['archive']].join(' ')}>
				<Navbar setIsLoginOpen={setIsLoginOpen} />
				<main className={styles['collections']}>
					<Toolbar />
					<Collection
						setIsLoginOpen={setIsLoginOpen}
						issues={ISSUES_SET['compliance']}
						title="Compliance"
					/>
					<Collection
						setIsLoginOpen={setIsLoginOpen}
						issues={ISSUES_SET['consent']}
						title="Consent"
					/>
					<Collection
						setIsLoginOpen={setIsLoginOpen}
						issues={ISSUES_SET['mental']}
						title="Mental Health"
					/>
					<Footer />
				</main>
			</div>
		</>
	);
}

ChaLayout.propTypes = {
	issues: PropTypes.array.isRequired,
};

function LoginButton({ setIsLoginOpen }) {
	const { setUserLoggedIn, isLogged } = useContext(AppContext);
	if (isLogged) {
		return (
			<button
				onClick={() => {
					localStorage.removeItem('is-user-login');
					setUserLoggedIn(false);
				}}
			>
				Log out
			</button>
		);
	}
	return (
		<button
			onClick={() => {
				setIsLoginOpen(true);
			}}
		>
			Login
		</button>
	);
}

LoginButton.propTypes = {
	setIsLoginOpen: PropTypes.any,
};

function Collection({ issues, title, setIsLoginOpen }) {
	const { isLogged } = useContext(AppContext);
	console.log(`IS USER LOGGED IN: ${isLogged}`);
	console.log(`ISSUES:`, issues);
	if (!isLogged) {
		return (
			<section
				className={styles['collection']}
				onClick={() => {
					setIsLoginOpen(true);
				}}
			>
				<h3>{title}</h3>
				<div className={styles['issues']}>
					{issues.map(({ id, cover }) => {
						return (
							<span className={styles['issue']} key={id}>
								<img src={cover} width={1024} />
							</span>
						);
					})}
				</div>
			</section>
		);
	}
	return (
		<section className={styles['collection']}>
			<h3>{title}</h3>
			<div className={styles['issues']}>
				{issues.map(({ id, url, cover }) => {
					return (
						<a
							href={url}
							className={styles['issue']}
							rel="noreferrer"
							key={id}
							target={'_blank'}
						>
							<img src={cover} width={1024} />
						</a>
					);
				})}
			</div>
		</section>
	);
}

Collection.propTypes = {
	title: PropTypes.string.isRequired,
	issues: PropTypes.array.isRequired,
	setIsLoginOpen: PropTypes.func.isRequired,
};
